var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "calendar_svg__a",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 39"
  }, /*#__PURE__*/React.createElement("image", {
    width: 40,
    height: 39,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAnCAYAAAB9qAq4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGySURBVFhH7ZjPKwVRFMe/jxJFvdiQ8iM/svL8A8RK2SAbO+QvsGLJHyJsraysFLJhgx1h4a28lHqFSIl7uuc215vXnRm3O/Ne3U9Nc867Z27nzfkxZyb3I0AN08Dn+BxOAds5eZyt8I8RXG4G19D1CUjuYMrUvIPhHPwqA3e78lyNhz3g9VHKHWNAz6yUTZROgacTKbf1AYNLUq6ksRkYWARahQ0TdvBoHigesJIB+RFg4YaVaiHO0jmifMuCJHwHqdIU9G9aOllhXq6D8NMa2UTxJlJCpUVTXqaGDu1H+ypWA5fMDk7sAEPLrDDUJlQ+DYu1cWETBbWZqy0pd00CM8dSVtB+evvRHPRtxpbkIXaBD7FDkrcZF/y7zWRFPeWg+Q72zgHtBVYc8l6UA4rC6kniAt9mHBLfwXuRIxR+dVRCE4u+rgYKnf3+YJ0GiBj4ENsSv4o/Sn+nXZrrdL4/gedzVgQ0lNJwqkPrZEfQu4l69zBUsW8ztngHbanzKi5sAN3TrDiEZsGLNVYEsas4K4xVnMYEbYK+z2iEHRxdDxmlCn0M0AiHuMbwbcYW76AdwC83m7uW0azeBgAAAABJRU5ErkJggg=="
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Imagem 5",
    fill: "url(#calendar_svg__a)",
    d: "M0 0h40v40H0z"
  })));
}
export default SvgCalendar;